export const formatSegment = (str) => {
  return str
    .replace(/([A-Z])/g, ' $1')
    .trim()
    .replace(/^./, (s) => s.toUpperCase());
};

export const enhanceFieldName = (fieldName, values) => {
  const parts = fieldName.split('.');
  const result = [];
  let currentLocationIndex = null;
  let i = 0;

  while (i < parts.length) {
    if (parts[i] === 'farmLocations' && i + 1 < parts.length && /^\d+$/.test(parts[i + 1])) {
      const locIdx = parseInt(parts[i + 1], 10);
      currentLocationIndex = locIdx;
      const locDesc = values?.farmLocations?.[locIdx]?.description;
      const locLabel = `Location ${locIdx + 1}`;
      result.push(locDesc ? `${locLabel}, (${locDesc})` : locLabel);
      i += 2;
    } else if (parts[i] === 'risks' && i + 1 < parts.length && /^\d+$/.test(parts[i + 1])) {
      const riskIdx = parseInt(parts[i + 1], 10);
      const riskDesc =
        currentLocationIndex !== null
          ? values?.farmLocations?.[currentLocationIndex]?.risks?.[riskIdx]?.description
          : undefined;
      const riskLabel = `Risk ${riskIdx + 1}`;
      result.push(riskDesc ? `${riskLabel}, (${riskDesc})` : riskLabel);
      i += 2;
    } else {
      result.push(formatSegment(parts[i]));
      i++;
    }
  }

  return result.join('. ');
};
